import { useQuery } from '@apollo/client'
import { useEnv } from '@/hooks/useEnv'
import SHORTEN_URL_QUERY from '@gql/ShortenUrlQuery.gql'

const useShortenCurrentUrl = () => {
  const { isLiffReady } = useEnv()

  const url = isLiffReady && liff?.permanentLink?.createUrl()
  const { data } = useQuery(SHORTEN_URL_QUERY, { variables: { url }, skip: !isLiffReady })

  return data?.shortenUrl
}

export default useShortenCurrentUrl
